// Las tres tarjetas de la caja de Crear —Producto, Avatar y Referencia— arriba de la caja del
// chat, cuando el panel se abre desde el Asistente de Crear
// (ADR-2026-10-13-las-tarjetas-de-crear-en-el-panel-del-asistente). Son las MISMAS tarjetas
// (`TarjetaDeReferencia`, en su versión chica) atadas a los adjuntos del chat: lo que se elige
// entra al mensaje que sigue, y la X lo saca. Tocarlas abre el selector de fuentes del chat en
// su pestaña.

import { Package, Upload, User } from 'lucide-react';
import { TarjetaDeReferencia } from '../../pages/v2/modes/redes/TarjetaDeReferencia';
import { palabraDeModeloActual } from '../../lib/nombreDeModelo';
import { useChatAtlas } from '../ChatAtlasContext';
import { useEntornoChatAtlas } from '../entornoContext';
import type { IdDeFuente } from './ModalDeFuentes';

/** Los adjuntos que muestran las tarjetas (y que por eso la caja no repite como miniatura). */
export const esAdjuntoDeTarjeta = (kind: string): boolean =>
  kind === 'product' || kind === 'model' || kind === 'image' || kind === 'video' || kind === 'moodboard';

export const TarjetasDeReferenciaDelChat: React.FC<{ onAbrir: (pestana: IdDeFuente) => void }> = ({ onAbrir }) => {
  const chat = useChatAtlas();
  const entorno = useEntornoChatAtlas();
  const productos = chat.adjuntos.filter((a) => a.kind === 'product');
  const modelos = chat.adjuntos.filter((a) => a.kind === 'model');
  // Con las imágenes, la carpeta de Estilos: es una referencia, y va adentro de su tarjeta
  // como en Crear (ADR-2026-10-18-el-moodboard-en-el-selector-de-fuentes-2).
  const subidas = chat.adjuntos.filter((a) => a.kind === 'image' || a.kind === 'video' || a.kind === 'moodboard');
  const quitar = (lista: { id: string }[]) => () => lista.forEach((a) => chat.quitarAdjunto(a.id));
  const modelo = palabraDeModeloActual().singular;
  return (
    <div className="flex gap-1.5">
      <TarjetaDeReferencia
        chica
        rotulo="Producto"
        Icono={Package}
        adjuntos={productos}
        carpeta={{ imagenes: entorno.productos.map((p) => p.imageUrl).filter(Boolean), tono: 'azul' }}
        fondo="bg-[#EEF3FF]"
        onAbrir={() => onAbrir('productos')}
        onQuitar={quitar(productos)}
      />
      <TarjetaDeReferencia
        chica
        rotulo={modelo.charAt(0).toUpperCase() + modelo.slice(1)}
        Icono={User}
        adjuntos={modelos}
        carpeta={{ imagenes: entorno.modelos.map((m) => m.thumbUrl || m.thumbnailUrl).filter(Boolean), tono: 'celeste' }}
        fondo="bg-[#ECF5FF]"
        onAbrir={() => onAbrir('modelos')}
        onQuitar={quitar(modelos)}
      />
      <TarjetaDeReferencia
        chica
        rotulo="Referencia"
        Icono={Upload}
        adjuntos={subidas}
        carpeta={{ imagenes: [], tono: 'cian', relleno: <Upload className="h-3.5 w-3.5" strokeWidth={2.25} /> }}
        fondo="bg-[#EAFAFC]"
        // Abre en Estilos (ADR-2026-10-19-el-vacio-de-estilos-muestra-el-resultado); donde
        // no se ofrece, el selector cae en "Subir archivo".
        onAbrir={() => onAbrir('moodboards')}
        onQuitar={quitar(subidas)}
      />
    </div>
  );
};

export default TarjetasDeReferenciaDelChat;
